export default class VideoPlayer {
	static init() {
		const videoItems = document.querySelectorAll('[data-video-wrapper]');
		videoItems.forEach(video => new VideoPlayer(video) );
    }

    constructor(video) {
        this.video = video;

        if (!this.video) return;

		this.button = this.video.querySelector('[data-play-video]');
		this.videoPlayer = this.video.querySelector('[data-video]');

		if(this.button){
			this.button.addEventListener('click', e => {
				this.playVideo();
			});
		}

		if(this.videoPlayer){
			this.videoPlayer.addEventListener('click', e => {
				this.pauseVideo();
			});
		}
	}

	playVideo() {
		this.video.firstElementChild.classList.add('is-hidden');
		this.videoPlayer.play();
		this.videoPlayer.focus();
    }

    pauseVideo() {
		this.video.firstElementChild.classList.remove('is-hidden');
		this.videoPlayer.pause();
    }
}